
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import packageJson from '../../../package.json';
import Code from '~/components/Code';
export const HTMLImport = () => {
  return <div>
      <Code className="html" mdxType="Code">
        {`<link rel="stylesheet" type="text/css" href="//cdn.drawbotics.com/vanilla-drylus/${packageJson.version}/drylus.css" />
<script src="//cdn.drawbotics.com/vanilla-drylus/${packageJson.version}/drylus.js"></script>`}
      </Code>
    </div>;
};

const layoutProps = {
  HTMLImport
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

<h1>{`Component kit`}</h1>
<p><strong parentName="p">{`Installation guide`}</strong></p>
<h2>{`React components`}</h2>
<p>{`If you're using `}<inlineCode parentName="p">{`drylus`}</inlineCode>{` in a React project install like so:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install @drawbotics/react-drylus@latest
`}</code></pre>
<p>{`The usage for each component is explained in the respective page.`}</p>
<h2>{`Vanilla`}</h2>
<p>{`If you're working on a vanilla (or React-less) project, you should use the standard CSS and JS bundles to handle the styling of your page and components.`}</p>

<p>{`Include the CSS and JS bundles somewhere in your index:`}</p>
<HTMLImport mdxType="HTMLImport" />
<p>{`If you prefer to import via the npm package you can include them like so:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import '@drawbotics/vanilla-drylus/dist/drylus.css';
import drylus from  '@drawbotics/vanilla-drylus/dist/drylus.js';
`}</code></pre>
<p>{`And then initialise the JS bundle through:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`drylus.default.all();
`}</code></pre>
<p><strong parentName="p">{`NOTE`}</strong>{`
Since the styles are built from React, the global styles are set by the `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component, so don't forget to wrap your application with:`}</p>
<pre><code parentName="pre" {...{}}>{`<div class="Drylus-ThemeProvider__root">...</div>
`}</code></pre>
<p>{`To enable styles throughout.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;